import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'AdminMetrics',
  description: 'A page for admin metrics',
  categories: ['Page', 'Admin', 'Metrics'],
  props: t.object({}),
})


